<template>
    <q-select filled v-model="optionComputed" :options="optionsComputed" :label="label" @update:modelValue="selectOption"
        :dense="true" :hint="hint" :useInput="enableAutocomplete" input-debounce="0" @filter="filterResult"
        :clearable="enableAutocomplete" lazy-rules :rules="rules">
        <template v-slot:no-option>
            <q-item>
                <q-item-section class="text-grey">
                    Sin resultados
                </q-item-section>
            </q-item>
        </template>
    </q-select>
</template>

<script lang="ts">
import { computed, defineComponent, reactive, toRefs } from 'vue';

import { OptionDto } from '@/dtos';

interface Props {
    option?: string;
    options?: OptionDto[];
    label?: string;
    hint?: string;
    value?: number;
    enableAutocomplete?: boolean,
    isRequired?: boolean;
}

export default defineComponent({
    name: 'IdentificationSelectComponent',
    props: {
        option: { type: String },
        options: { type: Array as () => OptionDto[] },
        label: { type: String },
        hint: { type: String },
        value: { type: Number },
        enableAutocomplete: {
            type: Boolean,
            default: false
        },
        isRequired: { type: Boolean }
    },
    emits: ['option_selected', 'update:option', 'update:options'],
    setup(props: Props, { emit }) {
        const optionComputed = computed({
            get() { return props.option },
            set(newValue) { emit('update:option', newValue) }
        });

        const optionsComputed = computed({
            get() { return props.options },
            set(newValue) { emit('update:options', newValue) }
        });

        const config = reactive({
            rules: (props.isRequired) ? [] : [(val) => (val && val.length > 0) || 'El campo es requerido']
        });



        const selectOption = (option: OptionDto) => {
            emit('option_selected', option);
        }

        const filterResult = (val: string, update: (fn: () => void) => void) => {
            if (val === '') {
                update(() => {
                    emit('update:options', null);
                })
                return;
            }

            update(() => {
                const needle = val.toLowerCase();
                const results = props.options?.filter(o => o.label.toLowerCase().indexOf(needle) > -1);
                emit('update:options', results);
            });
        }

        return {
            ...toRefs(config),
            optionComputed,
            optionsComputed,
            selectOption,
            filterResult
        }
    }
});
</script>